import { useSearchParams } from 'react-router-dom';
import { useSearchChannelPosts } from '@/hooks/api/useSearchChannelPosts';
import { AppLayout } from '@/components/layout/AppLayout';
import { Menu } from '@/components/layout/Menu';
import InfiniteScroll from 'react-infinite-scroller';
import { ChannelPostTileElement } from '@/components/ChannelPostTileElement';
import { SpriteSvg } from '@/components/common/SpriteSvg';
import { useLoading } from '@/providers/LoadingProvider';
import { Suspense, useEffect } from 'react';

export const ChannelPosts = () => {
  const { setShowLoading } = useLoading();
  const [searchParams] = useSearchParams();
  const { infiniteQuery } = useSearchChannelPosts();
  const keyword = searchParams.get('keyword') || '';

  const { data, isLoading, isFetching, fetchNextPage } = infiniteQuery(keyword);

  useEffect(() => {
    setShowLoading(isLoading);
  }, [isLoading]);

  return (
    <AppLayout>
      <div className="global-container">
        <Menu />

        <div className="content-main search">
          <section className="movies">
            {data && data.pages[0].total_count > 0 && (
              <InfiniteScroll
                loadMore={() => {
                  !isFetching && fetchNextPage();
                }}
                hasMore={data.pages[data.pages.length - 1].has_next}
                className={'items'}
              >
                {data.pages.map((resp) =>
                  resp.channel_posts.map((channelPost) => (
                    <ChannelPostTileElement key={`${channelPost.id}`} channel_post={channelPost} />
                  ))
                )}
              </InfiniteScroll>
            )}

            {data && data.pages[0].total_count == 0 && (
              <section className="search-result">
                <div className="empty-msg">
                  <SpriteSvg name={'icon-search'} className={'i'} />
                  <p>
                    動画が見つかりませんでした
                    <br />
                    キーワードを変更して検索してください
                  </p>
                </div>
              </section>
            )}
          </section>
        </div>
      </div>
    </AppLayout>
  );
};
